module Core {
    angular.module('core').filter('priceFormat', [() => {
        return (prix: number = 0): string => {
            var price = prix.toFixed(2);

            return price.replace('.', ',') + " €";
        };
    }]);
}